<template>
    <div>
      <base-dialog v-model="showDialog" :title="$t('chats.administrative-chat')"
      :okBtnText="$t('create')" :okBtnVariant="'success'" :cancelBtnText="$t('back')" :cancelBtnVariant="'secondary'"
      :okFn="createChatUser.value ? () => { createChat() } : null" :cancelFn="() => { $emit('toggleShowAdministrativeChat') }">
        <template>
          <div><span v-if="userTypeChatProf">{{ $t('professional') }}</span><span v-else>{{ $t('patient') }}</span></div>
          <base-select searchable clearable avoidDefaultSort :loading="createChatUser.loading" :options="createChatUser.options" valueProp="id" label="name" v-model="createChatUser.value" @search="userTypeChatProf ? searchProfByName($event) : searchPatientByName($event)" :placeholder="userTypeChatProf ? $t('chats.select-prof') : $t('chats.select-patient')">
            <template #option="data">
              <div>
                <img class="photo-option" :src="getUserPhoto(createChatUser.options, data.option.value)" alt=""/> <span>{{data.option.label}}</span>
              </div>
            </template>
          </base-select>
          <base-textarea v-if="createChatUser.value" :rows="1" :max-rows="5" class="mt-2" v-model="newMessage" :placeholder="$t('chats.new-message')"></base-textarea>
          <attach-file v-if="createChatUser.value && !userTypeChatProf"></attach-file>
          <base-select v-if="createChatUser.value && userTypeChatProf" searchable clearable avoidDefaultSort :loading="interconsultationPatient.loading" :options="interconsultationPatient.options" valueProp="id" label="name" v-model="interconsultationPatient.value" @search="searchPatientByName($event)" :placeholder="$t('chats.select-patient')">
            <template #option="data">
              <div>
                <img class="photo-option" :src="getUserPhoto(interconsultationPatient.options, data.option.value)" alt=""/> <span>{{data.option.label}}</span>
              </div>
            </template>
          </base-select>
        </template>
      </base-dialog>
    </div>
</template>
<script>

import BaseDialog from '@/components/base/BaseDialog'
import SearchRepository from '@/repositories/SearchRepository'
import ProfessionalRepository from '@/repositories/ProfessionalRepository'
import AttachFile from '@/components/base/forms/AttachFile'
import BaseTextarea from '@/components/base/forms/BaseTextarea.vue'

export default {
    components: {
        BaseDialog,
        BaseTextarea,
        AttachFile
    },
    props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        userTypeChatProf: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data () {
        return {
            showAdministrativeDialog: false,
            interconsultationPatient: {
                loading: false,
                options: [],
                value: null
            },
            createChatUser: {
                loading: false,
                options: [],
                value: null
            },
            newMessage: null
        }
    },
    methods: {
        searchPatientByName (name) {
            if (name && name.length >= 3) {
                ProfessionalRepository.getProfPatients(name).then((response) => {
                if (this.userTypeChatProf) {
                    this.interconsultationPatient.options = response.data
                } else {
                    this.createChatUser.options = response.data
                }
                })
            }
        },
        searchProfByName (name) {
            if (name && name.length >= 3) {
                SearchRepository.getProfsByName(name).then(response => {
                this.createChatUser.options = response.data.data
                })
            }
        },
        getUserPhoto (options, id) {
            let user = options.find(item => item.id === id)
            return user.photo || this.defaultImg
        }
    },
    computed: {
        defaultImg () {
            return this.userTypeChatProf ? '/static-appopensalud/img/icons/morillas-svg-icons/primary/doctor.svg' : '/static-appopensalud/img/icons/morillas-svg-icons/primary/user.svg'
        }
    }
}
</script>
<style lang="scss">
.photo-option{
  border-radius: 50%;
  padding: 0;
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/chat-interconsultations/AdministrativeChatModal.vue